import React from 'react'
import"./AboutPhase4.css"
const AboutPhase4 = () => {
  return (
    <div className='aboutPhase4'>
          
        <h3 className="headtitle3">My Values & Beliefs</h3>
        <div className="division">
        <div className="leftside">
        <h3 className="subtitle3">RELIABILITY</h3>
        <p className="paratwos"> Being dependable and trustworthy in fulfilling responsibilities and commitments.</p> 
       <br></br>           
        <h3 className="subtitle3">DILIGENCE
</h3>
        <p className="paratwos">Putting in consistent effort and attention to detail in tasks and projects. </p>
        <br></br> 
        <h3 className="subtitle3">PROFESSONALISM
</h3>
        <p className="paratwos"> Conducting oneself with integrity, respect, and accountability in the workplace. </p>
        <br></br><br></br> 
        <h3 className="subtitle3">TEAMWORK
</h3>
        <p className="paratwos">Collaborating effectively with colleagues to achieve common goals. </p>
        <br></br> 
        <h3 className="subtitle3">ADAPTABILITY
</h3>
        <p className="paratwos">Being flexible and open to change in order to meet evolving work demands. </p>
        <br></br> 
        <h3 className="subtitle3">EFFICIENCY
</h3>
        <p className="paratwos">Maximizing productivity and using resources effectively to achieve results.</p>
        <br></br> 
        <h3 className="subtitle3">PUNTUALITY
</h3>
        <p className="paratwos">Respecting schedules and deadlines by being on time and prepared for work </p>
        <br></br> 
        </div>

        

        <div className="rightside">

        <h3 className="subtitle3">Meritocracy</h3>
        <p className="paratwos"> Believing in the value of hard work and skills as the basis for advancement and recognition.</p>
    
        <h3 className="subtitle3">Fairness</h3>
        <p className="paratwos">Ensuring equitable treatment and opportunities for all employees regardless of background or status.</p>
        <h3 className="subtitle3">Innovation</h3>
        <p className="paratwos"> Valuing creativity and initiative to drive progress and competitive advantage.</p>
    
        <h3 className="subtitle3">Ethical Conduct</h3>
        <p className="paratwos"> Upholding moral principles and integrity in decision-making and interactions.</p>
    
        <h3 className="subtitle3">Respect for Diversity</h3>
        <p className="paratwos"> Embracing differences in perspectives, backgrounds, and ideas to foster inclusivity and innovation.</p>
    
        <h3 className="subtitle3">Health and Safety:</h3>
        <p className="paratwos"> Prioritizing the well-being and safety of employees in the workplace.</p>
    
        <h3 className="subtitle3">Long-term Vision</h3>
        <p className="paratwos"> Planning and acting with foresight to ensure sustainable growth and success.</p>
    
        <h3 className="subtitle3">Transparency</h3>
        <p className="paratwos"> Promoting openness and clear communication in all business operations.</p>


        </div>
        </div>
        <h3 className="headtitle3">Why Work With Me</h3>
        <p className="paratwo">I have acquired skills HTML,CSS,Javascript amongest use of frameworks like ReactJs,NextJs and also Typescript.I also pursed Diploma in Information Communication Technology in a certified Institution.I have the ability to buil effective relationships with my collegues by to my communication skills.I have analytical skills and creativity in solving complex problems.  </p>
        <p className="paratwo">Moreover,here are some  more compelling reasons why you might choose to work with me:Reliability and Accountability,Adaptability and Flexibility,Passion and Initiative and the Continuous Improvement.

</p>
        
        <h3 className="headtitle3">A Few More Words About Myself</h3>
        <p className="paratwo">
<b>Passionate: </b>I approach my work and interests with enthusiasm and dedication.
<br></br><b>Resourceful:</b> I have a knack for finding creative solutions and making the most of available resources.
<br></br><b>Resilient:</b> I bounce back from setbacks and challenges with a positive attitude and determination.
<br></br><b>Detail-oriented:</b> I pay attention to the finer points and ensure tasks are completed thoroughly and accurately.
<br></br><b>Inspirational:</b> I have a knack for motivating others through your actions, ideas, and positive attitude.
<br></br><b>Inquisitive:</b> I have a curious nature and enjoy learning new things and exploring different perspectives.
<br></br><b>Tenacious: </b>I am persistent and don't give up easily when pursuing your goals or solving problems.
<br></br><b>Empathetic:</b>I understand and connect with others' emotions and perspectives, making you approachable and supportive.
<br></br><b>Adventurous</b> I embrace new experiences and challenges, seeking opportunities to grow and expand your horizons.
<br></br><b>Calm under Pressure:</b> I maintain composure and focus during stressful situations, making you a reliable team member in demanding circumstances.</p>
       
    </div>
  )
}

export default AboutPhase4